module.exports = __webpack_public_path__ + "static_portal/img/blended_legs_back_concept2.2a8109e2.webp";